import type { ReactNode } from "react";

export interface EmptyValueProps {
	/**
	 * Custom content to display instead of the default "-"
	 * @default "-"
	 */
	children?: ReactNode;
	/**
	 * Additional CSS classes to apply
	 */
	className?: string;
}

/**
 * EmptyValue Component
 *
 * Displays a muted "-" character (or custom content) to represent empty or missing values.
 * Commonly used in tables, data grids, and detail views.
 *
 * @example
 * ```tsx
 * // Basic usage
 * <EmptyValue />
 *
 * // Custom content
 * <EmptyValue>N/A</EmptyValue>
 *
 * // With custom styling
 * <EmptyValue className="text-gray-400 italic" />
 *
 * // Custom aria label
 * <EmptyValue ariaLabel="Email not provided" />
 * ```
 */
export function EmptyValue({
	children = "–",
	className = "",
}: EmptyValueProps) {
	return (
		<span className={`text-gray-400 select-none ${className}`}>{children}</span>
	);
}
